<template lang="pug"> 
  title-tab(:msg="$t('title.transaction-report')")
    n-tap-01
</template>
<script>
import NTap01 from '@/views/TransactionReport/childs/P01'

export default {
  components:{
    NTap01, 
  }, 
}
</script> 